import React from 'react';
import { Box, Paper, Typography, useTheme } from '@mui/material';
import { HourglassEmptyOutlined as HourglassIcon } from '@mui/icons-material';
import { CaseStatusData } from '../types/CaseStatusData';
import { CARD_PADDING } from '../caseStatusTheme';
import { useCaseStatusLanguage } from '../../../../routes/CaseStatus/CaseStatusLanguageProvider';

type Props = { data: CaseStatusData };

const PaymentProcessingCard = ({ data }: Props) => {
  const theme = useTheme();
  const { t } = useCaseStatusLanguage();
  const amber = theme.palette.amber.main;

  return (
    <Paper elevation={1} sx={{ p: 0, overflow: 'hidden' }} data-testid="payment-processing-card">
      <Box sx={{ p: CARD_PADDING, backgroundColor: `${amber}14`, textAlign: 'center' }}>
        <HourglassIcon sx={{ color: amber, fontSize: 40 }} />
        <Typography
          variant="h6"
          data-testid="payment-processing-title"
          sx={{ fontWeight: 700, color: amber, mt: 0.5 }}
        >
          {t('PaymentBeingProcessed')}
        </Typography>
        <Typography variant="body2" sx={{ mt: 0.5, color: theme.palette.grey[600] }}>
          {t('PaymentProcessingTime')}
        </Typography>
      </Box>

      {data.kid && (
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            backgroundColor: theme.palette.grey[100],
            px: CARD_PADDING,
            py: 1.5,
          }}
        >
          <Box sx={{ textAlign: 'left' }}>
            <Typography variant="caption" color="text.secondary" sx={{ display: 'block' }}>
              {t('PaymentReferenceKID')}
            </Typography>
            <Typography
              sx={{ fontWeight: 700, fontVariantNumeric: 'tabular-nums' }}
              data-testid="payment-processing-kid"
            >
              {data.kid}
            </Typography>
          </Box>
        </Box>
      )}
    </Paper>
  );
};

export default PaymentProcessingCard;
